import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
// import { mockDataTeam } from "../../../../data/mockData";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
// import "./style.css";
import {
  insertModuleData,
  fetchModuleData,
  deleteModule,
} from "../../../../services/apiService";
import { toast } from "react-toastify";
import EditMstModule from "./EditMstModule";
import Topbar from "../../../../scenes/global/Topbar";

const GyanniMstModule = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const clientId = localStorage.getItem("clientId");
  const orgId = localStorage.getItem("organizationid");
  const UserId = localStorage.getItem("UserId");

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [moduleData, setModuleData] = useState([]);
  // const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editRowData, setEditRowData] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [filterModel, setFilterModel] = useState({
    items: [],
  });

  const handleFilterChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
  };

  // const openModal = () => {
  //   setIsModalOpen(true);
  // };

  // const closeModal = () => {
  //   setIsModalOpen(false);
  // };

  const [insertData, setInsertData] = useState({
    moduleName: "",
    moduleDescription: "",
    insertURL: "",
    syncURL: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInsertData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const parsedClientId = Number(clientId);
        const parsedOrgId = Number(orgId);

        const requestedData = {
          clientid: parsedClientId,
          organizationid: parsedOrgId,
        };

        const countResponse = await fetchModuleData(requestedData);
        const total = countResponse?.details?.total || 0;

        const dataRequest = {
          clientid: parsedClientId,
          organizationid: parsedOrgId,
          limit: total,
        };

        const initialData = await fetchModuleData(dataRequest);
        setModuleData(initialData?.details?.values || []);
      } catch (error) {
        console.error("Error fetching clients data:", error);
        setError("Failed to fetch clients data.");
      } finally {
        setLoading(false);
      }
    };

    if (clientId && orgId) {
      fetchData();
    }
  }, [clientId, orgId]);

  // insert
  const handleInsertModuleData = async (e) => {
    e.preventDefault();
    try {
      const response = await insertModuleData(insertData);
      if (response.success) {
        toast.success("Module Added !!");
      } else {
        toast.error(
          response?.message || "Module insertion failed. Please try again."
        );
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  const columns = [
    // { field: 'id', headerName: 'ID', width: 100, cellClassName: "name-column--cell", flex: 1 },
    { field: "modulename", headerName: "Module Name", width: 200, flex: 1 },
    {
      field: "moduledescription",
      headerName: "Description",
      width: 300,
      flex: 1,
    },
    { field: "url", headerName: "URL", width: 200, flex: 1 },
    { field: "syncurl", headerName: "Sync URL", width: 200, flex: 1 },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      filterable: false,
      flex: 1,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <IconButton
            onClick={() => handleEdit(params.id)}
            style={{ color: "#6870fa" }}
            size="small"
          >
            <BorderColorIcon fontSize="small" />
          </IconButton>
          <IconButton
            onClick={() => handleDelete(params.row)}
            style={{ color: "red" }}
            size="small"
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </div>
      ),
    },
  ];

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleEdit = (id) => {
    const rowData = moduleData.find((item) => item.id === id);
    console.log(rowData);

    setEditRowData(rowData);
    setIsEditModalOpen(true); // this is the modal for <EditMstModule />
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
    setEditRowData(null);
  };

  const handleDelete = async (row) => {
    if (!row?.id) return;

    if (
      window.confirm(`Are you sure you want to delete "${row.modulename}"?`)
    ) {
      try {
        const result = await deleteModule(row.id);
        window.location.reload();
      } catch (error) {
        console.error("Failed to delete module:", error);
      }
    }
  };

  return (
    <>
      <div className="mt-4">
        <Topbar />
      </div>

      <Box m="20px" style={{ backgroundColor: colors.primary[400] }}>
        <div className="p-4 flex items-center justify-between">
          <h2 className="">Module Details</h2>
          <div
            style={{ backgroundColor: colors.blueAccent[500] }}
            className="text-white px-4 py-2 rounded-sm"
          >
            <button onClick={openModal} className="font-medium">
              {" "}
              <AddIcon /> Add
            </button>
          </div>
        </div>

        <Box
          m="0 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <DataGrid
            rows={moduleData}
            columns={columns}
            filterModel={filterModel}
            onFilterModelChange={handleFilterChange}
            className="p-4"
          />
        </Box>

        {/* // edit modal pop up  */}
        <div
          className={`fixed inset-0 bg-gray-500 bg-opacity-50 z-50 transition-opacity ${
            isModalOpen ? "block" : "hidden"
          }`}
        >
          <div className="flex justify-center items-center min-h-screen">
            <div className="bg-white p-6 rounded-lg shadow-lg w-6/12">
              <h2 className="text-2xl text-center font-semibold mb-4">
                Add Module to Role
              </h2>

              <form onSubmit={handleInsertModuleData}>
                <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Module Name
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      name="moduleName"
                      onChange={handleInputChange}
                      value={setInsertData.moduleName}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Module Description
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      name="moduleDescription"
                      onChange={handleInputChange}
                      value={setInsertData.moduleDescription}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      URL
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      name="insertURL"
                      onChange={handleInputChange}
                      value={setInsertData.insertURL}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="keyPersonEmail"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      SYNC URL
                    </label>
                    <input
                      type="text"
                      id="keyPersonEmail"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      name="syncURL"
                      onChange={handleInputChange}
                      value={setInsertData.syncURL}
                    />
                  </div>

                  {/* Submit and Close Buttons */}
                  <div className="col-span-2 flex justify-between space-x-4">
                    <button
                      type="submit"
                      onClick={handleInsertModuleData}
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                      Submit
                    </button>
                    <button
                      onClick={closeModal}
                      className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-400 focus:outline-none"
                    >
                      Close Modal
                    </button>
                  </div>
                </div>
              </form>

              {/* Close button */}
            </div>
          </div>
        </div>

        <EditMstModule
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          rowData={editRowData}
        />
      </Box>
    </>
  );
};

export default GyanniMstModule;
